// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"18873ec0","887":"bebf7421"}[chunkId] + ".chunk.js";
};